import React, { useCallback, useState } from "react";
import useChatChannelList from "../hook/useChatChannelList";
import { Avatar, Icon, Popover, ResourceItem, ResourceList, Spinner, Text } from "@shopify/polaris";
import { ChatMajor } from "@shopify/polaris-icons";
import { EnableChatComponent } from "../EnableChatComponent";
import { handleMessageText } from "src/pages/chat/components/ChatList";

export function ChatMenuMarkup() {
  const [open, setOpen] = useState(false);
  const { list, loading } = useChatChannelList();

  const toggleOpen = useCallback(() => setOpen(!open), [open]);

  const ActiveStatus = ({ status }: { status: string }) => {
    const isActive = status.toLowerCase() === "active now";
    return (
      <div
        style={{
          backgroundColor: isActive ? "#30cc45" : "#ddd",
          width: 10,
          height: 10,
          borderRadius: "50%",
          marginRight: "0.5rem",
          position: "absolute",
          bottom: -1,
          right: -10,
        }}
      ></div>
    );
  };

  return (
    <Popover
      activator={
        <div className="Polaris-TopBar-Menu__ActivatorWrapper">
          <div
            onClick={toggleOpen}
            style={{ display: "flex", position: "relative", fontSize: "14pt", alignItems: "center" }}
            className="Polaris-TopBar-Menu__Activator"
          >
            {loading ? (
              <Spinner accessibilityLabel="Small spinner example" size="small" />
            ) : (
              <Icon source={ChatMajor} />
            )}
            {list.filter((x) => (x.unread || 0) > 0).length > 0 && (
              <span
                style={{
                  position: "absolute",
                  top: -15,
                  zIndex: 100,
                  right: -10,
                }}
              >
                <span
                  style={{
                    padding: "2px 6px",
                    backgroundColor: "red",
                    color: "white",
                    borderRadius: "0.5rem",
                    fontSize: "10pt",
                  }}
                >
                  {list.filter((x) => (x.unread || 0) > 0).length}
                </span>
              </span>
            )}
          </div>
        </div>
      }
      active={open}
      onClose={toggleOpen}
    >
      {list.length > 0 && (
        <Popover.Pane>
          <div className="p-2">
            <EnableChatComponent />
          </div>
          <ResourceList
            items={list}
            renderItem={(item) => {
              const media = (
                <div style={{ position: "relative" }}>
                  <Avatar customer name={item.name || ""} source={item.image || ""} />
                  <ActiveStatus status={item.onlineStatus || ""} />
                </div>
              );
              return (
                <ResourceItem
                  id={item.channel + ""}
                  media={media}
                  onClick={() => { }}
                  url={`/chat?channel=${item.channel}&name=${item.name}`}
                  external={window.location.pathname.split("/")[1] !== "chat"}
                >
                  <Text variant="bodySm" fontWeight="bold" as="h3">
                    {item.name}
                  </Text>
                  <small style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {handleMessageText(item.lastMessage)}
                  </small>
                </ResourceItem>
              );
            }}
          />
        </Popover.Pane>
      )}
    </Popover>
  );
}
